import { read_f32, Sink } from "../../helpers/serializerHelpers";

export class PointCloudCartesian {
    public x: number = 0; // in m
    public y: number = 0; // in m
    public z: number = 0; // in m
    public rangeRate: number = 0; // in m/s

    public deserialize(bytes: Sink) {
        this.x = read_f32(bytes);
        this.y = read_f32(bytes);
        this.z = read_f32(bytes);
        this.rangeRate = read_f32(bytes);
        return this;
    }

    public getLength() {
        return 4 * 4;
    }
}
